module.exports = __webpack_public_path__ + "img/progressImg.6baa63a7.png";